import { Injectable } from '@angular/core';
import { APIService } from './api.service';

/** A pending auto-created Skill awaiting curation (status=0, auto_created=true). */
export interface CurationCandidate {
  id: number;
  name: string;
  nearest_match_name: string | null;
  nearest_match_score: number | string | null;
  sample_vacancy_title: string | null;
}

export interface CurationPage {
  data: CurationCandidate[];
  meta: {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
}

export interface BulkResult {
  processed: number;
  processed_ids: number[];
  skipped: { id: number; reason: string }[];
}

@Injectable({ providedIn: 'root' })
export class SkillCurationService extends APIService {

  public list(page: number = 1): Promise<CurationPage> {
    return this.get<CurationPage>('/skills/curation', 'Could not load curation queue', {
      params: { page }
    });
  }

  public approve(id: number): Promise<any> {
    return this.post<object, any>(`/skills/${id}/curation/approve`, {}, 'Skill approved');
  }

  public reject(id: number): Promise<any> {
    return this.post<object, any>(`/skills/${id}/curation/reject`, {}, 'Skill rejected');
  }

  public merge(id: number, targetId: number): Promise<any> {
    return this.post<object, any>(`/skills/${id}/curation/merge`, { target_id: targetId }, 'Skill merged');
  }

  public reclassifyDevelopment(id: number): Promise<any> {
    return this.post<object, any>(`/skills/${id}/curation/reclassify-development`, {}, 'Moved to Development');
  }

  public bulk(action: 'approve' | 'reject', ids: number[]): Promise<BulkResult> {
    return this.post<object, BulkResult>('/skills/curation/bulk', { action, ids });
  }
}
